import React, { useEffect, useState } from "react";
import { View, StyleSheet, TouchableOpacity, Text } from "react-native";

import GoalPresetsList from "./GoalPresetsList";
import Icons from "../../common/icons/index";
import fontStyles from "../../../fonts";
import AppTheme from "../../AppTheme";
import cardStyles from "../../home/cards/cardStyles";

export default function AddNewGoal(props) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [title, setTitle] = useState("Set a Goal");
  const [buttonText] = useState("Create a goal with a custom timeframe");

  useEffect(() => {
    setTitle(isCollapsed ? "Set a Goal" : "Set a Weekly Goal");
  }, [isCollapsed]);

  return (
    <View
      style={[
        cardStyles.container,
        {
          paddingHorizontal: 8,
        },
      ]}
    >
      <View
        style={[
          cardStyles.card,
          {
            marginLeft: 0,
            marginRight: 0,
            minHeight: 50,
            padding: 8,
          },
        ]}
      >
        <GoalPresetsList
          {...props}
          buttonText={buttonText}
          showGoals={!isCollapsed}
        >
          <View style={styles.container}>
            <Text style={fontStyles.h4}>{title}</Text>

            <TouchableOpacity
              onPress={() => setIsCollapsed(!isCollapsed)}
              style={styles.row}
            >
              <Text
                style={[
                  fontStyles.h5medium,
                  isCollapsed
                    ? { color: AppTheme.DEFAULT_COLOR }
                    : { color: "#ABADB3" },
                ]}
              >
                {isCollapsed ? "Show" : "Hide"} Popular Goals
              </Text>
              <Icons.ArrowDown
                isCollapsed={isCollapsed}
                styles={styles.icon}
                color={isCollapsed ? AppTheme.DEFAULT_COLOR : "#ABADB3"}
                width={9}
                height={9}
              />
            </TouchableOpacity>
          </View>
        </GoalPresetsList>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 4,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
  },
});
